export const UPDATE = "virtualRooms/UPDATE";
export const APPEND = "virtualRooms/APPEND";
export const UPDATE_ONE = "virtualRooms/UPDATE_ONE";
export const DESTROY = "virtualRooms/DESTROY";
export const LOADING = "virtualRooms/LOADING";
